import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom'; // Add this import
import UpcomingTrips from '../components/home/UpcomingTrips';
import Header from '../components/Header';
import Footer from '../components/Footer';
import MobileHeader from '../components/MobileHeader';
import ContactCard from '../components/ContactCard';
import { searchTrips } from '../functions/FetchTrips';
import '../styles/destinations.css';
import FloatingActionButton from '../components/home/FloatingActionButton';
import PopUpModal from '../components/PopUpModal'; // Add this import
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

const Destinations = () => {
    // State for contact form overlay
    const [isContactFormOpen, setIsContactFormOpen] = useState(false);

    // State for trips
    const [trips, setTrips] = useState([]);
    const [loadingTrips, setLoadingTrips] = useState(true);
    const [tripsError, setTripsError] = useState(null);

    const location = useLocation(); // Get location object from router

    const [showModal, setShowModal] = useState(false); // Add state for popup modal

    const [bannerImage, setBannerImage] = useState('');

    // Scroll to top on navigation
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    // Toggle contact form overlay
    const toggleContactForm = () => {
        setIsContactFormOpen(!isContactFormOpen);
    };

    // Effect to control body scroll
    useEffect(() => {
        if (isContactFormOpen) {
            // Prevent scrolling when overlay is open
            document.body.style.overflow = 'hidden';
        } else {
            // Allow scrolling when overlay is closed
            document.body.style.overflow = 'unset';
        }

        // Cleanup function to restore scroll when component unmounts
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isContactFormOpen]);

    // Fetch trips based on location from URL
    useEffect(() => {
        const params = new URLSearchParams(location.search); // Use location.search
        const loc = params.get('location');
        setLoadingTrips(true);
        searchTrips(loc)
            .then(data => {
                setTrips(data);
                setTripsError(null);
            })
            .catch(() => {
                setTripsError("Failed to load trips.");
            })
            .finally(() => setLoadingTrips(false));
    }, [location.search]);

    // Show popup modal after 8 seconds (like Home page)
    useEffect(() => {
        const timer = setTimeout(() => setShowModal(true), 8000);
        return () => clearTimeout(timer);
    }, []);

    // Fetch Destination Page banner image from Firestore
    useEffect(() => {
        async function fetchBannerImage() {
            try {
                const docRef = doc(db, "Images", "AllImages");
                const docSnap = await getDoc(docRef);
                if (docSnap.exists() && docSnap.data()["Destination Page Image"] && docSnap.data()["Destination Page Image"].url) {
                    setBannerImage(docSnap.data()["Destination Page Image"].url);
                }
            } catch (error) {
                // fallback: do nothing
            }
        }
        fetchBannerImage();
    }, []);

    return (
        <>
            <div className="d-none d-lg-block">
                <Header />
            </div>
            <MobileHeader />
            <div className="destinations-page">
                {/* Banner Section */}
                <div
                    className="destinations-banner"
                    style={{
                        backgroundImage:
                            `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('${bannerImage || "https://images.unsplash.com/photo-1500835556837-99ac94a94552?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80"}')`
                    }}
                >
                    <div className="container">
                        <div className="banner-content-wrapper">
                            {/* Left side - Title and description */}
                            <div className="banner-text">
                                <h1>Explore Our Destinations</h1>
                                <p>Discover amazing trips and packages tailored to your travel preferences. From romantic getaways to adventure-filled expeditions, we have something for everyone.</p>

                                {/* Buttons Container (Desktop & Mobile) */}
                                <div className="banner-buttons-desktop">
                                    {/* WhatsApp Button */}
                                    <a href="https://wa.me/919220424206" target="_blank" rel="noopener noreferrer" className="btn btn-whatsapp">
                                        <i className="fab fa-whatsapp"></i> Chat on WhatsApp
                                    </a>
                                    {/* Connect with Expert Button (Desktop only) */}
                                    <button onClick={toggleContactForm} className="btn btn-connect-expert d-none d-md-inline-flex d-lg-none">
                                        <i className="fas fa-paper-plane"></i> Send Enquiry
                                    </button>
                                </div>
                                
                                {/* Mobile-only contact form - visible directly in the hero */}
                                <div className="mobile-hero-contact d-block d-lg-none">
                                    <ContactCard isHero={true} whiteText={true} />
                                </div>
                            </div>
                            
                            {/* Right side - Contact Card (desktop only) */}
                            <div className="hero-contact-container d-none d-lg-block">
                                <ContactCard isHero={true} whiteText={true} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    {/* Display trips using the UpcomingTrips component */}
                    <div className="trips-container">
                        <h2 className="text-center mb-1">Available Trips & Packages</h2> {/* Reduced margin-bottom */}
                        <p className="text-center mb-3"> {/* Reduced margin-bottom */}
                            Explore our curated selection of trips. Use the filters above to find the perfect match for your next adventure.
                        </p>

                        {/* Using the UpcomingTrips component to display the trips */}
                        <UpcomingTrips hideControls={true} trips={trips} loading={loadingTrips} error={tripsError} />
                    </div>
                </div>
                {/* <div className='upc'>
                    <UpcomingTrips />
                </div> */}
            </div>

            {/* Sticky "Connect with Expert" button for mobile */}
            <div className="sticky-cta-button d-md-none">
                <button onClick={toggleContactForm}>
                    <i className="fas fa-headset"></i> Connect with Expert
                </button>
            </div>

            {/* Mobile Contact Form Overlay - Only show for non-hero interactions */}
            {isContactFormOpen && (
                <div className="mobile-contact-overlay" onClick={toggleContactForm}>
                    <div className="mobile-contact-form" onClick={(e) => e.stopPropagation()}>
                        <div className="mobile-contact-close">
                            <button className="mobile-contact-close-btn" onClick={toggleContactForm}>×</button>
                        </div>
                        {/* Pass isOverlay prop and whiteText prop */}
                        <ContactCard isOverlay={true} whiteText={true} />
                    </div>
                </div>
            )}

            <FloatingActionButton hideOnMobile={true} />
            <Footer />
            <PopUpModal isOpen={showModal} onClose={() => setShowModal(false)} />
        </>
    );
};

export default Destinations;
